import React, { useEffect, useState } from "react";
import FormCustomization from "./FormCustomization";
import { Badge, Col, Container, Form, ListGroup, Row, Spinner } from "react-bootstrap";
import { IoDuplicateOutline } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import Swal from "sweetalert2";
import { FaRegEdit } from "react-icons/fa";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import SplitPane from "react-split-pane";
import FormFieldLibrary from "./FormFieldLibrary";
import { useParams } from "react-router-dom";
import UseToggle from "../../../../Hooks/UseToggle";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { globalFormManagementServices } from "../../../../APIServices/globalFormManagementServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import ScorePercentageGraph from "../CommonFiles/ScorePercentageGraph";
import RangeScale from "../CommonFiles/RangeScale";
const FormEditor = ({
  handleFormFieldDelete,
  handleUpdateFormField,
  handleDuplicateFormField,
  handleAddFormField,
  setFormFields,
  setToggleLibrary,
  toggleLibrary,
  formFields,
  setFormId,
  formId,
  version,
  setVersion
}) => {
  const { toggle, setToggle, toggle1, setToggle1 } = UseToggle();
  const [fieldId, setFieldId] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [domainLabel, setDomainLabel] = useState("");
  const [domainCode, setDomainCode] = useState("");
  const [selectScaleIndex, setSelectScaleIndex] = useState(null);
  const [formMetadataList, setFormMetadataList] = useState([]);
  const [formFieldLibraryList, setFormFieldLibraryList] = useState([]);
  const [customForm, setCustomForm] = useState("");
  const [loading, setLoading] = useState(false);
  const [fieldLoading, setFieldLoading] = useState(false);
  const [conditionaLogicTab, setConditionaLogicTab] = useState("field")
  const [activeTab, setActiveTab] = useState("general");
  const [formCategory, setFormCategory] = useState("")
  const [formType, setFormType] = useState("")
  let { studyId } = useParams();
  const [buttonLoader, setButtonLoader] = useState(false)
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const getStudyLevelForm = async (e) => {
    setLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelForm(
      studyId,
      LoginCat,
      "active",
    );
    setFormMetadataList(data?.data || []);
    if (formId) {
      let getSingleForm = (data?.data || [])?.find(item => item.formId === formId)
      setVersion(getSingleForm?.version || 1)
    }
    setLoading(false);
  };

  const getGlobalFormFieldGroupLibrary = async (e) => {
    let data = await globalFormManagementServices.getGlobalFormFieldGroupLibrary();
    setFormFieldLibraryList(data?.data || []);
    if (!toggleLibrary) {
      setCategoryId((data?.data || [])[0]?.categoryId);
    }
  };

  useEffect(() => {
    if (!toggleLibrary) {
      getGlobalFormFieldGroupLibrary();
    }
  }, [toggleLibrary]);

  const getStudyLevelFormFieldsByVersion = async (e) => {
    setFieldLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelFormFieldsByVersion(
      studyId,
      formId,
      version
    );
    setFormFields(data?.data?.formFields || []);
    setFieldLoading(false);
  };

  const addUpdateGlobalFormFields = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Form Fields!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {};
        userData.studyId = studyId;
        userData.formId = formId;
        userData.formFields = formFields
        let data = await studyLevelFormManagementServices.addUpdateStudyLevelFormFields(userData);
        if (data?.statusCode === 200) {
          getStudyLevelFormFieldsByVersion();
          getStudyLevelForm();
        }
        setButtonLoader(false)
      }
    });
  };

  const days = Array.from({
    length: 31
  }, (_, index) => {
    const day = index + 1;
    return day.toString().padStart(2, '0');
  });

  const hours12 = Array.from({
    length: 12
  }, (_, index) => {
    const hour = index + 1;
    return hour.toString().padStart(2, '0');
  });

  const hours24 = Array.from({ length: 24 }, (_, index) => {
    const hour = index + 1;
    return hour.toString().padStart(2, '0');
  });

  const minuteSecond = Array.from({ length: 60 }, (_, index) => {
    const minuteSecondData = index + 1;
    return minuteSecondData.toString().padStart(2, '0');
  });

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 150 }, (_, index) => currentYear - index);

  const textMonths = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
  ];
  const numberMonths = Array.from({ length: 12 }, (_, index) => {
    const numberMonth = index + 1;
    return numberMonth.toString().padStart(2, '0');
  });

  function isMMMFormat(dateStr) {
    let regexMMM = /\b(MMM)\b/i;
    const parts = dateStr.split('_');
    if (dateStr === "DD_MMM_YYYY" || dateStr === "YYYY_MMM_DD") {
      return /^[A-Za-z]{3}$/.test(parts[1]);
    } else if (regexMMM.test(dateStr)) {
      return true;
    } else {
      return false;
    }
  }

  const chunkOptionArray = (arr = [], chunks) => {
    const result = [];
    const size = Math.ceil(arr.length / chunks);
    for (let i = 0; i < chunks; i++) {
      result.push(arr.slice(i * size, (i + 1) * size));
    }
    return result;
  };

  const getDynamicColor = (index, total, baseColor) => {
    const minLightness = 30;
    const maxLightness = 60;

    const percent = total <= 1 ? 0 : index / (total - 1);
    const lightness = maxLightness - percent * (maxLightness - minLightness);

    if (baseColor === "red") {
      return `hsl(0, 70%, ${lightness}%)`;
    } else {
      return `hsl(120, 50%, ${lightness}%)`;
    }
  };

  function isFirstPartYYYY(dateStr) {
    return dateStr.startsWith("YYYY");
  }

  function isFirstPartYYYY(dateStr) {
    return dateStr.startsWith("YYYY");
  }

  useEffect(() => {
    getStudyLevelForm();
  }, []);

  useEffect(() => {
    if (formId && version) {
      getStudyLevelFormFieldsByVersion();
    }
  }, [formId, version]);

  const handleDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;

    const reordered = Array.from(formFields);
    const [movedItem] = reordered.splice(source.index, 1);
    reordered.splice(destination.index, 0, movedItem);
    setFormFields(reordered);
  };

  const nameCount = {};
  const duplicatesFieldName = [];
  for (const item of formFields) {
    nameCount[item.fieldName] = (nameCount[item.fieldName] || 0) + 1;
  }
  for (const item of formFields) {
    if (nameCount[item.fieldName] > 1) {
      duplicatesFieldName.push(item.id);
    }
  }

  return (
    <>
      <SplitPane split="vertical" minSize={"20%"} className="position-relative" style={{ height: "calc(100vh - 145px)" }}>
        {loading ? (
          <PageLoader/>
        ) : formMetadataList?.length === 0 ? (
          <NoDataFoundTable MSG={"Form not folund!"} />
        ) : (
          <div className="p-2">
            <ListGroup>
              {formMetadataList.map((metadata, index) => (
                <ListGroup.Item action 
                  title={metadata?.formLabel}
                  onClick={() => { setFormId(metadata?.formId); setCustomForm(metadata?.customForm); setDomainLabel(metadata?.domainLabel); setDomainCode(metadata?.domainCode); setFormCategory(metadata?.category); setFormType(metadata?.formType); setVersion(metadata?.version) }}
                  key={index}
                  style={{padding: "7px 0px 7px 10px"}}
                  className={`hstack ${formId === metadata?.formId && "selectedMenu"}`}
                >
                  <span>{metadata?.formLabel}</span>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </div>
        )}
        <Container fluid>
          <Row>
            <Form.Group as={Col} md={formId ? 11 : 12} className="p-0">
              <div
                className="hstack flex-column justify-content-between w-100"
                style={{ height: "calc(100vh - 145px)" }}
              >
                {!formId ?
                  <div className="hstack justify-content-center h-100 fw-bold text-muted">
                    Select Any Form!
                  </div>
                  : fieldLoading ?
                    <div
                      className="hstack justify-content-center"
                      style={{ height: "calc(100vh - 179px)" }}
                    >
                      <PageLoader/>
                    </div>
                    : formFields.length === 0 ?
                      <div className="hstack justify-content-center h-100 fw-bold text-muted">
                        Add Field!
                      </div>
                      :
                      <>
                        <DragDropContext onDragEnd={handleDragEnd}>
                          <Droppable droppableId="form-formFields-droppable">
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                className="overflow-auto w-100 bg-light pb-3 bg-blue-subtle"
                                style={{ height: "calc(100vh - 145px)" }}
                              >
                                <Container fluid>
                                  <Row>
                                    {formFields.map((field, index) => (
                                      <Draggable
                                        key={field?.id}
                                        draggableId={String(field?.id)}
                                        index={index}
                                      >
                                        {(provided) => (
                                          <Form.Group
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            as={Col}
                                            md={Number(field?.columnSize)}
                                          >
                                            <div className={
                                              field?.type === "heading"
                                                ? "pe-3 py-2 mt-3"
                                                : `bg-white border rounded p-3 mt-3 position-relative ${duplicatesFieldName?.includes(field?.id) && "border-danger"}`
                                            }>
                                              {field?.type !== "heading" &&
                                                <div className="position-absolute" style={{ top: -13 }}>
                                                  <Badge bg={`${(field?.conditionalFields || [])?.length > 0 ? "danger" : "primary"}`} className="br3 px-3 text-capitalize">{field?.type}</Badge>
                                                  {field?.customField === "yes" ?
                                                    <Badge bg="primary" className="br3 px-3 text-capitalize mx-2">Custom</Badge>
                                                    : field?.groupField === "yes" &&
                                                    <Badge bg="primary" className="br3 px-3 text-capitalize mx-2">Group</Badge>
                                                  }
                                                </div>
                                              }
                                              <div className="d-flex justify-content-end align-items-center">
                                                <div className="z-1 d-flex gap-3">
                                                  <FaRegEdit
                                                    title="Edit"
                                                    className="CP"
                                                    onClick={(e) => {
                                                      setFieldId(field?.id);
                                                      setToggle();
                                                      setActiveTab("general");
                                                      e.stopPropagation();
                                                    }}
                                                    style={{ pointerEvents: "auto" }}
                                                  />
                                                  <IoDuplicateOutline
                                                    className="CP"
                                                    title="Duplicate"
                                                    onClick={(e) => { handleDuplicateFormField(field?.id); e.stopPropagation() }}
                                                    style={{ pointerEvents: "auto" }}
                                                  />
                                                  <RiDeleteBin6Line
                                                    className="text-danger CP"
                                                    title="Delete"
                                                    onClick={(e) => { handleFormFieldDelete(index); e.stopPropagation() }}
                                                    style={{ pointerEvents: "auto" }}
                                                  />
                                                </div>
                                              </div>
                                              {field?.type === "heading" ? (
                                                <div className="d-flex justify-content-between align-items-center">
                                                  <h5 className={`d-flex gap-2 mb-0`}>
                                                    <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                      {field?.fieldLabelType ?
                                                        <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                        :
                                                        <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                      }
                                                    </span>
                                                  </h5>
                                                </div>
                                              ) : field?.customField === "yes" ? (
                                                <>
                                                  {(field?.type === "text" || field?.type === "number") ?
                                                    <div className="hstack gap-2 w-100">
                                                      <div className="w-100">
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          <h5 className={`d-flex gap-2 mb-0`}>
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                              {field?.fieldLabelType ?
                                                                <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                                :
                                                                <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>}
                                                            </span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                            {field?.fieldHelp &&
                                                              <span>
                                                                <BsFillQuestionCircleFill
                                                                  title={field?.fieldHelp}
                                                                  style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                />
                                                              </span>
                                                            }
                                                          </h5>
                                                        </div>
                                                        <Form.Control
                                                          type={field?.type}
                                                          placeholder={field?.fieldPlaceholder || ""}
                                                          style={{ width: field?.fieldSize }}
                                                        />
                                                      </div>
                                                      {field?.fieldUnit === "yes" &&
                                                        <div className="w-100">
                                                          <div className="d-flex justify-content-between align-items-center my-2">
                                                            {field?.fieldUnit === "yes" &&
                                                              <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-0`}>
                                                                <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.fieldUnitLabel}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                                {field?.fieldUnitHelp &&
                                                                  <span>
                                                                    <BsFillQuestionCircleFill
                                                                      title={field?.fieldUnitHelp}
                                                                      style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                    />
                                                                  </span>
                                                                }
                                                              </h5>
                                                            }
                                                          </div>
                                                          <Form.Select
                                                            className="br3"
                                                            required
                                                            style={{ fontSize: 12 }}
                                                            disabled={(field?.unitOptions || []).length === 0}
                                                          >
                                                            <option>Select Unit Option</option>
                                                            {(field?.unitOptions || [])?.map((option, i) => (
                                                              <option key={i} value={option?.option}>
                                                                {option?.option}
                                                              </option>
                                                            ))}
                                                          </Form.Select>
                                                        </div>
                                                      }
                                                    </div>
                                                    : field?.type === "dropdown" ? (
                                                      <>
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          <h5 className={`d-flex gap-2 mb-0`}>
                                                            <div className="d-flex gap-2">
                                                              <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                                {field?.fieldLabelType ?
                                                                  <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                                  :
                                                                  <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                                }
                                                              </span>
                                                              {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                            </div>
                                                            {field?.fieldHelp &&
                                                              <span>
                                                                <BsFillQuestionCircleFill
                                                                  title={field?.fieldHelp}
                                                                  style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                />
                                                              </span>
                                                            }
                                                          </h5>
                                                        </div>
                                                        <Form.Select
                                                          className="br3"
                                                          style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                          disabled={(field?.options || []).length === 0}
                                                        >
                                                          <option>Select Option</option>
                                                          {(field?.options || [])?.map((option, i) => (
                                                            <option key={i} value={option?.option}>
                                                              {option?.option}
                                                            </option>
                                                          ))}
                                                        </Form.Select>
                                                      </>
                                                    ) : field?.type === "radio" ? (
                                                      <>
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          <h5 className={`d-flex gap-2 mb-0`}>
                                                            <div className="d-flex gap-2">
                                                              <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                                {field?.fieldLabelType ?
                                                                  <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                                  :
                                                                  <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                                }
                                                              </span>
                                                              {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                            </div>
                                                            {field?.fieldHelp &&
                                                              <span>
                                                                <BsFillQuestionCircleFill
                                                                  title={field?.fieldHelp}
                                                                  style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                />
                                                              </span>
                                                            }
                                                          </h5>
                                                        </div>
                                                        <Row>
                                                          {chunkOptionArray(field?.options, (field?.optionShowColumn || 1))?.map((chunk, colIdx) => (
                                                            <Form.Group key={colIdx} as={Col} md={12 / (field?.optionShowColumn || 1)} className={field?.radioVisible === "horizontal" && 'hstack gap-2'}>
                                                              {chunk?.map((option, i) => (
                                                                <Form.Check
                                                                  key={i}
                                                                  type={field?.type}
                                                                  label={option.option}
                                                                  name={`radioGroup_${field?.id}`}
                                                                  style={{ width: field?.radioVisible === "horizontal" ? "auto" : `${Number(field?.fieldWidthSize || 100)}%` }}
                                                                />
                                                              ))}
                                                            </Form.Group>
                                                          ))}
                                                        </Row>
                                                      </>
                                                    ) : field?.type === "checkbox" ? (
                                                      <>
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          <h5 className={`d-flex gap-2 mb-0`}>
                                                            <div className="d-flex gap-2">
                                                              <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                                {field?.fieldLabelType ?
                                                                  <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                                  :
                                                                  <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                                }
                                                              </span>
                                                              {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                            </div>
                                                            {field?.fieldHelp &&
                                                              <span>
                                                                <BsFillQuestionCircleFill
                                                                  title={field?.fieldHelp}
                                                                  style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                />
                                                              </span>
                                                            }
                                                          </h5>
                                                        </div>
                                                        <Row>
                                                          {chunkOptionArray(field?.options, (field?.optionShowColumn || 1))?.map((chunk, colIdx) => (
                                                            <Form.Group key={colIdx} as={Col} md={12 / (field?.optionShowColumn || 1)} className={field?.radioVisible === "horizontal" && 'hstack gap-2'}>
                                                              {chunk?.map((option, i) => (
                                                                <Form.Check
                                                                  key={i}
                                                                  type={field?.type}
                                                                  label={option.option}
                                                                  name={field?.label}
                                                                  style={{ width: field?.radioVisible === "horizontal" ? "auto" : `${Number(field?.fieldWidthSize || 100)}%` }}
                                                                />
                                                              ))}
                                                            </Form.Group>
                                                          ))}
                                                        </Row>
                                                      </>
                                                    ) : field?.type === "date" ? (
                                                      <>
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          <h5 className={`d-flex gap-2 mb-0`}>
                                                            <div className="d-flex gap-2">
                                                              <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                                {field?.fieldLabelType ?
                                                                  <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                                  :
                                                                  <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                                }
                                                              </span>
                                                              {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                            </div>
                                                            {field?.fieldHelp &&
                                                              <span>
                                                                <BsFillQuestionCircleFill
                                                                  title={field?.fieldHelp}
                                                                  style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                />
                                                              </span>
                                                            }
                                                          </h5>
                                                        </div>
                                                        <div className="w-100 hstack gap-2">
                                                          {isFirstPartYYYY(field?.dateFormat) ?
                                                            <div className="w-100">
                                                              <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                                {field?.yearLabel}
                                                              </h5>
                                                              <Form.Select
                                                                className="br3"
                                                                required
                                                                style={{ fontSize: 12 }}
                                                              >
                                                                <option>Select Year</option>
                                                                <option>UNK</option>
                                                                {years?.map((year, i) => (
                                                                  <option key={i} value={year}>
                                                                    {year}
                                                                  </option>
                                                                ))}
                                                              </Form.Select>
                                                            </div>
                                                            :
                                                            <div className="w-100">
                                                              <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                                {field?.dayLabel}
                                                              </h5>
                                                              <Form.Select
                                                                className="br3"
                                                                required
                                                                style={{ fontSize: 12 }}
                                                              >
                                                                <option>Select Day</option>
                                                                <option>UNK</option>
                                                                {days?.map((day, i) => (
                                                                  <option key={i} value={day}>
                                                                    {day}
                                                                  </option>
                                                                ))}
                                                              </Form.Select>
                                                            </div>
                                                          }
                                                          <div className="w-100">
                                                            <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                              {field?.monthLabel}
                                                            </h5>
                                                            <Form.Select
                                                              className="br3"
                                                              required
                                                              style={{ fontSize: 12 }}
                                                            >
                                                              <option>Select Month</option>
                                                              <option>UNK</option>
                                                              {(isMMMFormat(field?.dateFormat) ? textMonths : numberMonths)?.map((month, i) => (
                                                                <option key={i} value={month}>
                                                                  {month}
                                                                </option>
                                                              ))}
                                                            </Form.Select>
                                                          </div>
                                                          {isFirstPartYYYY(field?.dateFormat) ?
                                                            <div className="w-100">
                                                              <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                                {field?.dayLabel}
                                                              </h5>
                                                              <Form.Select
                                                                required
                                                                style={{ fontSize: 12 }}
                                                              >
                                                                <option>Select Day</option>
                                                                <option>UNK</option>
                                                                {days?.map((day, i) => (
                                                                  <option key={i} value={day}>
                                                                    {day}
                                                                  </option>
                                                                ))}
                                                              </Form.Select>
                                                            </div>
                                                            :
                                                            <div className="w-100">
                                                              <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                                {field?.yearLabel}
                                                              </h5>
                                                              <Form.Select
                                                                className="br3"
                                                                required
                                                                style={{ fontSize: 12 }}
                                                              >
                                                                <option>Select Year</option>
                                                                <option>UNK</option>
                                                                {years?.map((year, i) => (
                                                                  <option key={i} value={year}>
                                                                    {year}
                                                                  </option>
                                                                ))}
                                                              </Form.Select>
                                                            </div>
                                                          }
                                                        </div>
                                                        {field?.dateFormat &&
                                                          <Form.Text style={{ fontSize: 10, fontWeight: 600 }}>
                                                            <b>Date Format:</b>{" "}
                                                            {(field?.dateFormat === "DD_MMM_YYYY" || field?.dateFormat === "YYYY_MMM_DD" || field?.dateFormat === "DD_MM_YYYY" || field?.dateFormat === "YYYY_MM_DD") ? (field?.dateFormat)?.replace(/_/g, "") : field?.dateFormat}
                                                          </Form.Text>
                                                        }
                                                      </>
                                                    ) : field?.type === "time" && (
                                                      <>
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          <h5 className={`d-flex gap-2 mb-0`}>
                                                            <div className="d-flex gap-2">
                                                              <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                                {field?.fieldLabelType ?
                                                                  <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                                  :
                                                                  <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                                }
                                                              </span>
                                                              {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                            </div>
                                                            {field?.fieldHelp &&
                                                              <span>
                                                                <BsFillQuestionCircleFill
                                                                  title={field?.fieldHelp}
                                                                  style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                />
                                                              </span>
                                                            }
                                                          </h5>
                                                        </div>
                                                        <div className="w-100 hstack gap-2">
                                                          <div className="w-100">
                                                            <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                              {field?.hourLabel}
                                                            </h5>
                                                            <Form.Select
                                                              className="br3"
                                                              required
                                                              style={{ fontSize: 12 }}
                                                            >
                                                              <option>Select Hour</option>
                                                              <option>UNK</option>
                                                              {(field?.clockTimeFormat === "24" ? hours24 : hours12)?.map((hour, i) => (
                                                                <option key={i} value={hour}>
                                                                  {hour}
                                                                </option>
                                                              ))}
                                                            </Form.Select>
                                                          </div>
                                                          <div className="w-100">
                                                            <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                              {field?.minuteLabel}
                                                            </h5>
                                                            <Form.Select
                                                              className="br3"
                                                              required
                                                              style={{ fontSize: 12 }}
                                                            >
                                                              <option>Select Minute</option>
                                                              <option>UNK</option>
                                                              {minuteSecond?.map((minute, i) => (
                                                                <option key={i} value={minute}>
                                                                  {minute}
                                                                </option>
                                                              ))}
                                                            </Form.Select>
                                                          </div>
                                                          {field?.timeFormat === "hhmmss" &&
                                                            <div className="w-100">
                                                              <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                                {field?.secondLabel}
                                                              </h5>
                                                              <Form.Select
                                                                className="br3"
                                                                required
                                                                style={{ fontSize: 12 }}
                                                              >
                                                                <option>Select Second</option>
                                                                <option>UNK</option>
                                                                {minuteSecond?.map((second, i) => (
                                                                  <option key={i} value={second}>
                                                                    {second}
                                                                  </option>
                                                                ))}
                                                              </Form.Select>
                                                            </div>
                                                          }
                                                        </div>
                                                      </>
                                                    )}
                                                  {(field?.referenceRangeLimit === "yes" || field?.referenceRangeIndicator === "yes" || field?.clinicalSignificance === "yes") &&
                                                    < div className="d-flex gap-2 w-100 mt-3">
                                                      {field?.referenceRangeLowerLimit === "yes" &&
                                                        <div className="w-100">
                                                          <div className="d-flex justify-content-between align-items-center my-2">
                                                            <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-0`}>
                                                              <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.referenceRangeLowerLimitLabel}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                              {field?.referenceRangeLowerLimitHelp &&
                                                                <span>
                                                                  <BsFillQuestionCircleFill
                                                                    title={field?.referenceRangeLowerLimitHelp}
                                                                    style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                  />
                                                                </span>
                                                              }
                                                            </h5>
                                                          </div>
                                                          {(field?.referenceRangeLowerLimitType === "text" || field?.referenceRangeLowerLimitType === "number") ?
                                                            <Form.Control
                                                              type={field?.referenceRangeLowerLimitType}
                                                              placeholder={field?.referenceRangeLowerLimitPlaceholder || ""}
                                                            />
                                                            : field?.referenceRangeLowerLimitType === "dropdown" ?
                                                              <Form.Select
                                                                style={{ fontSize: 12 }}
                                                                className="br3"
                                                                disabled={(field?.referenceRangeLowerLimitOptions || []).length === 0}
                                                              >
                                                                <option>Select Option</option>
                                                                {(field?.referenceRangeLowerLimitOptions || [])?.map((option, i) => (
                                                                  <option key={i} id={option?.id} value={option?.option}>
                                                                    {option?.option}
                                                                  </option>
                                                                ))}
                                                              </Form.Select>
                                                              : field?.referenceRangeLowerLimitType === "radio" &&
                                                              (field?.referenceRangeLowerLimitOptions || [])?.map((option, i) => (
                                                                <Form.Check
                                                                  key={i}
                                                                  type="radio"
                                                                  label={option?.option}
                                                                  name={`referenceRangeLowerLimit_${field.id}`}
                                                                />
                                                              ))
                                                          }
                                                        </div>
                                                      }
                                                      {field?.referenceRangeUpperLimit === "yes" &&
                                                        <div className="w-100">
                                                          <div className="d-flex justify-content-between align-items-center my-2">
                                                            <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-0`}>
                                                              <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.referenceRangeUpperLimitLabel}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                              {field?.referenceRangeUpperLimitHelp &&
                                                                <span>
                                                                  <BsFillQuestionCircleFill
                                                                    title={field?.referenceRangeUpperLimitHelp}
                                                                    style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                  />
                                                                </span>
                                                              }
                                                            </h5>
                                                          </div>
                                                          {(field?.referenceRangeUpperLimitType === "text" || field?.referenceRangeUpperLimitType === "number") ?
                                                            <Form.Control
                                                              type={field?.referenceRangeUpperLimitType}
                                                              placeholder={field?.referenceRangeUpperLimitPlaceholder || ""}
                                                            />
                                                            : field?.referenceRangeUpperLimitType === "dropdown" ?
                                                              <Form.Select
                                                                style={{ fontSize: 12 }}
                                                                className="br3"
                                                                disabled={(field?.referenceRangeUpperLimitOptions || []).length === 0}
                                                              >
                                                                <option>Select Option</option>
                                                                {(field?.referenceRangeUpperLimitOptions || [])?.map((option, i) => (
                                                                  <option key={i} id={option?.id} value={option?.option}>
                                                                    {option?.option}
                                                                  </option>
                                                                ))}
                                                              </Form.Select>
                                                              : field?.referenceRangeUpperLimitType === "radio" &&
                                                              (field?.referenceRangeUpperLimitOptions || [])?.map((option, i) => (
                                                                <Form.Check
                                                                  key={i}
                                                                  type="radio"
                                                                  label={option?.option}
                                                                  name={`referenceRangeUpperLimit_${field.id}`}
                                                                />
                                                              ))
                                                          }
                                                        </div>
                                                      }
                                                      {field?.referenceRangeIndicator === "yes" &&
                                                        <div className="w-100">
                                                          <div className="d-flex justify-content-between align-items-center my-2">
                                                            <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-0`}>
                                                              <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.referenceRangeIndicatorLabel}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                              {field?.referenceRangeIndicatorHelp &&
                                                                <span>
                                                                  <BsFillQuestionCircleFill
                                                                    title={field?.referenceRangeIndicatorHelp}
                                                                    style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                  />
                                                                </span>
                                                              }
                                                            </h5>
                                                          </div>
                                                          {field?.referenceRangeIndicatorOptions?.map((option, i) => (
                                                            <Form.Check
                                                              key={i}
                                                              type="radio"
                                                              label={option?.option}
                                                              name={`referenceRangeIndicator_${field?.id}`}
                                                            />
                                                          ))}
                                                        </div>
                                                      }
                                                      {field?.clinicalSignificance === "yes" &&
                                                        <div className="w-100">
                                                          <div className="d-flex justify-content-between align-items-center my-2">
                                                            <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-0`}>
                                                              <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.clinicalSignificanceLabel}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                              {field?.clinicalSignificanceHelp &&
                                                                <span>
                                                                  <BsFillQuestionCircleFill
                                                                    title={field?.clinicalSignificanceHelp}
                                                                    style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                  />
                                                                </span>
                                                              }
                                                            </h5>
                                                          </div>
                                                          <Form.Check
                                                            type="radio"
                                                            label="CS"
                                                            name={`clinicalSignificance_${field?.id}`}
                                                          />
                                                          <Form.Check
                                                            type="radio"
                                                            label="NCS"
                                                            name={`clinicalSignificance_${field?.id}`}
                                                          />
                                                        </div>
                                                      }
                                                    </div>
                                                  }
                                                  {field?.customRemark === "yes" &&
                                                    <div className="w-100">
                                                      <div style={{ marginTop: 7 }} className="d-flex justify-content-between align-items-center mb-2">
                                                        <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-0`}>
                                                          <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.customRemarkLabel}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                          {field?.customRemarkHelp &&
                                                            <span>
                                                              <BsFillQuestionCircleFill
                                                                title={field?.customRemarkHelp}
                                                                style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                              />
                                                            </span>
                                                          }
                                                        </h5>
                                                      </div>
                                                      <Form.Control
                                                        as="textarea"
                                                        placeholder={field?.customRemarkPlaceholder || ""}
                                                      />
                                                    </div>
                                                  }
                                                </>
                                              ) : field?.type === "dropdown" ? (
                                                <>
                                                  <div className="d-flex justify-content-between align-items-center my-2">
                                                    <h5 className={`d-flex gap-2 mb-0`}>
                                                      <div className="d-flex gap-2">
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                          {field?.fieldLabelType ?
                                                            <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                            :
                                                            <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                          }
                                                        </span>
                                                        {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                      </div>
                                                      {field?.fieldHelp &&
                                                        <span>
                                                          <BsFillQuestionCircleFill
                                                            title={field?.fieldHelp}
                                                            style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                          />
                                                        </span>
                                                      }
                                                    </h5>
                                                  </div>
                                                  <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                    <Form.Select
                                                      className="br3"
                                                      style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                      disabled={(field?.options || []).length === 0}
                                                    >
                                                      <option>Select Option</option>
                                                      {(field?.options || [])?.map((option, i) => (
                                                        <option key={i} value={option?.option}>
                                                          {option?.option}
                                                        </option>
                                                      ))}
                                                    </Form.Select>
                                                    {field?.customFieldRemark === "yes" &&
                                                      <>
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-0`}>
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >
                                                              {field?.customFieldRemarkLabel}
                                                            </span>
                                                          </h5>
                                                        </div>
                                                        <Form.Control
                                                          style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                          as="textarea"
                                                          placeholder={"Enter Remark"}
                                                        />
                                                      </>
                                                    }
                                                  </div>
                                                </>
                                              ) : field?.type === "radio" ? (
                                                <>
                                                  <div className="d-flex justify-content-between align-items-center my-2">
                                                    <h5 className={`d-flex gap-2 mb-0`}>
                                                      <div className="d-flex gap-2">
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                          {field?.fieldLabelType ?
                                                            <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                            :
                                                            <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                          }
                                                        </span>
                                                        {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                      </div>
                                                      {field?.fieldHelp &&
                                                        <span>
                                                          <BsFillQuestionCircleFill
                                                            title={field?.fieldHelp}
                                                            style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                          />
                                                        </span>
                                                      }
                                                    </h5>
                                                  </div>
                                                  <Row>
                                                    {chunkOptionArray(field?.options, (field?.optionShowColumn || 1))?.map((chunk, colIdx) => (
                                                      <Form.Group key={colIdx} as={Col} md={12 / (field?.optionShowColumn || 1)} className={field?.radioVisible === "horizontal" && 'hstack gap-2'}>
                                                        {chunk?.map((option, i) => (
                                                          <Form.Check
                                                            key={i}
                                                            type={field?.type}
                                                            label={option.option}
                                                            name={`radioGroup_${field?.id}`}
                                                            style={{ width: field?.radioVisible === "horizontal" ? "auto" : `${Number(field?.fieldWidthSize || 100)}%` }}
                                                          />
                                                        ))}
                                                      </Form.Group>
                                                    ))}
                                                  </Row>
                                                  {field?.customFieldRemark === "yes" &&
                                                    <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                      <div className="d-flex justify-content-between align-items-center my-2">
                                                        <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-0`}>
                                                          <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >
                                                            {field?.customFieldRemarkLabel}
                                                          </span>
                                                        </h5>
                                                      </div>
                                                      <Form.Control
                                                        style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                        as="textarea"
                                                        placeholder={"Enter Remark"}
                                                      />
                                                    </div>
                                                  }
                                                </>
                                              ) : field?.type === "checkbox" ? (
                                                <>
                                                  <div className="d-flex justify-content-between align-items-center my-2">
                                                    <h5 className={`d-flex gap-2 mb-0`}>
                                                      <div className="d-flex gap-2">
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                          {field?.fieldLabelType ?
                                                            <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                            :
                                                            <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                          }
                                                        </span>
                                                        {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                      </div>
                                                      {field?.fieldHelp &&
                                                        <span>
                                                          <BsFillQuestionCircleFill
                                                            title={field?.fieldHelp}
                                                            style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                          />
                                                        </span>
                                                      }
                                                    </h5>
                                                  </div>
                                                  <Row>
                                                    {chunkOptionArray(field?.options, (field?.optionShowColumn || 1))?.map((chunk, colIdx) => (
                                                      <Form.Group key={colIdx} as={Col} md={12 / (field?.optionShowColumn || 1)} className={field?.radioVisible === "horizontal" && 'hstack gap-2'}>
                                                        {chunk?.map((option, i) => (
                                                          <Form.Check
                                                            key={i}
                                                            type={field?.type}
                                                            label={option.option}
                                                            name={field?.label}
                                                            style={{ width: field?.radioVisible === "horizontal" ? "auto" : `${Number(field?.fieldWidthSize || 100)}%` }}
                                                          />
                                                        ))}
                                                      </Form.Group>
                                                    ))}
                                                  </Row>
                                                  {field?.customFieldRemark === "yes" &&
                                                    <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                      <div className="d-flex justify-content-between align-items-center my-2">
                                                        <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-0`}>
                                                          <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >
                                                            {field?.customFieldRemarkLabel}
                                                          </span>
                                                        </h5>
                                                      </div>
                                                      <Form.Control
                                                        style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                        as="textarea"
                                                        placeholder={"Enter Remark"}
                                                      />
                                                    </div>
                                                  }
                                                </>
                                              ) : field?.type === "textarea" ? (
                                                <>
                                                  <div className="d-flex justify-content-between align-items-center my-2">
                                                    <h5 className={`d-flex gap-2 mb-0`}>
                                                      <div className="d-flex gap-2">
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                          {field?.fieldLabelType ?
                                                            <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                            :
                                                            <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                          }
                                                        </span>
                                                        {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                      </div>
                                                      {field?.fieldHelp &&
                                                        <span>
                                                          <BsFillQuestionCircleFill
                                                            title={field?.fieldHelp}
                                                            style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                          />
                                                        </span>
                                                      }
                                                    </h5>
                                                  </div>
                                                  <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                    <Form.Control
                                                      as="textarea"
                                                      rows={4}
                                                      placeholder={field?.fieldPlaceholder || ""}
                                                      style={{ width: `${Number(field?.inputWidthSize || 100)}%` }}
                                                    />
                                                  </div>
                                                </>
                                              ) : field?.type === "range" ? (
                                                <>
                                                  <div className="d-flex justify-content-between align-items-center">
                                                    <h5 className={`d-flex gap-2 mb-0`}>
                                                      <div className="d-flex gap-2">
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                          {field?.fieldLabelType ?
                                                            <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                            :
                                                            <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                          }
                                                        </span>
                                                        {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                      </div>
                                                      {field?.fieldHelp &&
                                                        <span>
                                                          <BsFillQuestionCircleFill
                                                            title={field?.fieldHelp}
                                                            style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                          />
                                                        </span>
                                                      }
                                                    </h5>
                                                  </div>
                                                  <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                    <RangeScale
                                                      startLinePoint={Number(field?.startRange)}
                                                      endLinePoint={Number(field?.endRange)}
                                                      inputWidthSize={`${Number(field?.inputWidthSize || 100)}%`}
                                                      dataEntryType
                                                      rangeValue={0}
                                                    />
                                                    {field?.customFieldRemark === "yes" &&
                                                      <>
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-0`}>
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >
                                                              {field?.customFieldRemarkLabel}
                                                            </span>
                                                          </h5>
                                                        </div>
                                                        <Form.Control
                                                          style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                          as="textarea"
                                                          placeholder={"Enter Remark"}
                                                        />
                                                      </>
                                                    }
                                                  </div>
                                                </>
                                              ) : field?.type === "scale" ? (
                                                <>
                                                  <div className="d-flex justify-content-between align-items-center my-2">
                                                    <h5 className={`d-flex gap-2 mb-0`}>
                                                      <div className="d-flex gap-2">
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                          {field?.fieldLabelType ?
                                                            <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                            :
                                                            <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                          }
                                                        </span>
                                                        {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                      </div>
                                                      {field?.fieldHelp &&
                                                        <span>
                                                          <BsFillQuestionCircleFill
                                                            title={field?.fieldHelp}
                                                            style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                          />
                                                        </span>
                                                      }
                                                    </h5>
                                                  </div>
                                                  <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }} className="hstack">
                                                    {(field?.options || []).map((option, i) => {
                                                      const isFilled = selectScaleIndex !== null && i <= selectScaleIndex;
                                                      const total = selectScaleIndex !== null ? selectScaleIndex + 1 : (field?.options || []).length;
                                                      const backgroundColor = isFilled
                                                        ? getDynamicColor(i, total, "green")
                                                        : "transparent";
                                                      const borderColor = isFilled
                                                        ? getDynamicColor(i, total, "green")
                                                        : "#dee2e6";
                                                      return (
                                                        <div
                                                          key={i}
                                                          onClick={() => setSelectScaleIndex(i)}
                                                          className="p-1 px-2"
                                                          style={{
                                                            fontSize: 12,
                                                            cursor: "pointer",
                                                            background: backgroundColor,
                                                            border: `1px solid ${borderColor}`,
                                                            color: isFilled ? "#fff" : "#000",
                                                            transition: "all 0.3s ease",
                                                          }}
                                                        >
                                                          {option?.option}
                                                        </div>
                                                      );
                                                    })}
                                                  </div>
                                                  {field?.customFieldRemark === "yes" &&
                                                    <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                      <div className="d-flex justify-content-between align-items-center my-2">
                                                        <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-0`}>
                                                          <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >
                                                            {field?.customFieldRemarkLabel}
                                                          </span>
                                                        </h5>
                                                      </div>
                                                      <Form.Control
                                                        style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                        as="textarea"
                                                        placeholder={"Enter Remark"}
                                                      />
                                                    </div>
                                                  }
                                                </>
                                              ) : field?.type === "file" ? (
                                                <>
                                                  <div className="d-flex justify-content-between align-items-center my-2">
                                                    <h5 className={`d-flex gap-2 mb-0`}>
                                                      <div className="d-flex gap-2">
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                          {field?.fieldLabelType ?
                                                            <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                            :
                                                            <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                          }
                                                        </span>
                                                        {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                      </div>
                                                      {field?.fieldHelp &&
                                                        <span>
                                                          <BsFillQuestionCircleFill
                                                            title={field?.fieldHelp}
                                                            style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                          />
                                                        </span>
                                                      }
                                                    </h5>
                                                  </div>
                                                  <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                    <Form.Control
                                                      accept={field?.fieldFileType
                                                        ?.map((item) => item.value)
                                                        ?.join(", ")}
                                                      type={field?.type}
                                                      style={{ width: `${Number(field?.inputWidthSize || 100)}%` }}
                                                      placeholder={field?.fieldPlaceholder || ""}
                                                      disabled={(field?.fieldFileType || [])?.length === 0}
                                                    />
                                                    {(field?.fieldFileType || [])?.length > 0 &&
                                                      <Form.Text style={{ fontSize: 10, fontWeight: 600 }}>
                                                        <b>Supported File:</b>{" "}
                                                        {field?.fieldFileType
                                                          ?.map((item) => item.label)
                                                          ?.join(", ")}
                                                      </Form.Text>
                                                    }
                                                    {field?.customFieldRemark === "yes" &&
                                                      <>
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-0`}>
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >
                                                              {field?.customFieldRemarkLabel}
                                                            </span>
                                                          </h5>
                                                        </div>
                                                        <Form.Control
                                                          style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                          as="textarea"
                                                          placeholder={"Enter Remark"}
                                                        />
                                                      </>
                                                    }
                                                  </div>
                                                </>
                                              ) : (field?.type === "text" || field?.type === "number") ? (
                                                <div className="hstack gap-2 w-100">
                                                  <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                      <h5 className={`d-flex gap-2 mb-0`}>
                                                        <div className="d-flex gap-2">
                                                          <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                            {field?.fieldLabelType ?
                                                              <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                              :
                                                              <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                            }
                                                          </span>
                                                          {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                        </div>
                                                        {field?.fieldHelp &&
                                                          <span>
                                                            <BsFillQuestionCircleFill
                                                              title={field?.fieldHelp}
                                                              style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                            />
                                                          </span>
                                                        }
                                                      </h5>
                                                    </div>
                                                    <Form.Control
                                                      type={field?.type}
                                                      placeholder={field?.fieldPlaceholder || ""}
                                                    />
                                                  </div>
                                                  {field?.fieldUnit === "yes" &&
                                                    <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%`, marginTop: -9 }}>
                                                      <div className="d-flex justify-content-between align-items-center my-2">
                                                        {field?.fieldUnit === "yes" &&
                                                          <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-0`}>
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.fieldUnitLabel} {field?.fieldUnitName && `| ${field?.fieldUnitName}`}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                            {field?.fieldUnitHelp &&
                                                              <span>
                                                                <BsFillQuestionCircleFill
                                                                  title={field?.fieldUnitHelp}
                                                                  style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                />
                                                              </span>
                                                            }
                                                          </h5>
                                                        }
                                                      </div>
                                                      <Form.Select
                                                        className="br3"
                                                        required
                                                        style={{ fontSize: 12 }}
                                                        disabled={(field?.unitOptions || []).length === 0}
                                                      >
                                                        <option>Select Unit Option</option>
                                                        {(field?.unitOptions || [])?.map((option, i) => (
                                                          <option key={i} value={option?.option}>
                                                            {option?.option}
                                                          </option>
                                                        ))}
                                                      </Form.Select>
                                                    </div>
                                                  }
                                                </div>
                                              ) : field?.type === "date" ? (
                                                <>
                                                  <div className="d-flex justify-content-between align-items-center my-2">
                                                    <h5 className={`d-flex gap-2 mb-0`}>
                                                      <div className="d-flex gap-2">
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                          {field?.fieldLabelType ?
                                                            <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                            :
                                                            <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                          }
                                                        </span>
                                                        {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                      </div>
                                                      {field?.fieldHelp &&
                                                        <span>
                                                          <BsFillQuestionCircleFill
                                                            title={field?.fieldHelp}
                                                            style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                          />
                                                        </span>
                                                      }
                                                    </h5>
                                                  </div>
                                                  <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }} className="hstack gap-2">
                                                    {isFirstPartYYYY(field?.dateFormat) ?
                                                      <div className="w-100">
                                                        <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                          {field?.yearLabel}
                                                        </h5>
                                                        <Form.Select
                                                          className="br3"
                                                          required
                                                          style={{ fontSize: 12 }}
                                                        >
                                                          <option>Select Year</option>
                                                          <option>UNK</option>
                                                          {years?.map((year, i) => (
                                                            <option key={i} value={year}>
                                                              {year}
                                                            </option>
                                                          ))}
                                                        </Form.Select>
                                                      </div>
                                                      :
                                                      <div className="w-100">
                                                        <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                          {field?.dayLabel}
                                                        </h5>
                                                        <Form.Select
                                                          className="br3"
                                                          required
                                                          style={{ fontSize: 12 }}
                                                        >
                                                          <option>Select Day</option>
                                                          <option>UNK</option>
                                                          {days?.map((day, i) => (
                                                            <option key={i} value={day}>
                                                              {day}
                                                            </option>
                                                          ))}
                                                        </Form.Select>
                                                      </div>
                                                    }
                                                    <div className="w-100">
                                                      <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                        {field?.monthLabel}
                                                      </h5>
                                                      <Form.Select
                                                        className="br3"
                                                        required
                                                        style={{ fontSize: 12 }}
                                                      >
                                                        <option>Select Month</option>
                                                        <option>UNK</option>
                                                        {(isMMMFormat(field?.dateFormat) ? textMonths : numberMonths)?.map((month, i) => (
                                                          <option key={i} value={month}>
                                                            {month}
                                                          </option>
                                                        ))}
                                                      </Form.Select>
                                                    </div>
                                                    {isFirstPartYYYY(field?.dateFormat) ?
                                                      <div className="w-100">
                                                        <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                          {field?.dayLabel}
                                                        </h5>
                                                        <Form.Select
                                                          required
                                                          style={{ fontSize: 12 }}
                                                        >
                                                          <option>Select Day</option>
                                                          <option>UNK</option>
                                                          {days?.map((day, i) => (
                                                            <option key={i} value={day}>
                                                              {day}
                                                            </option>
                                                          ))}
                                                        </Form.Select>
                                                      </div>
                                                      :
                                                      <div className="w-100">
                                                        <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                          {field?.yearLabel}
                                                        </h5>
                                                        <Form.Select
                                                          className="br3"
                                                          required
                                                          style={{ fontSize: 12 }}
                                                        >
                                                          <option>Select Year</option>
                                                          <option>UNK</option>
                                                          {years?.map((year, i) => (
                                                            <option key={i} value={year}>
                                                              {year}
                                                            </option>
                                                          ))}
                                                        </Form.Select>
                                                      </div>
                                                    }
                                                  </div>
                                                  {field?.dateFormat &&
                                                    <Form.Text style={{ fontSize: 10, fontWeight: 600 }}>
                                                      <b>Date Format:</b>{" "}
                                                      {(field?.dateFormat === "DD_MMM_YYYY" || field?.dateFormat === "YYYY_MMM_DD" || field?.dateFormat === "DD_MM_YYYY" || field?.dateFormat === "YYYY_MM_DD") ? (field?.dateFormat)?.replace(/_/g, "") : field?.dateFormat}
                                                    </Form.Text>
                                                  }
                                                </>
                                              ) : field?.type === "time" ? (
                                                <>
                                                  <div className="d-flex justify-content-between align-items-center my-2">
                                                    <h5 className={`d-flex gap-2 mb-0`}>
                                                      <div className="d-flex gap-2">
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                          {field?.fieldLabelType ?
                                                            <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                            :
                                                            <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                          }
                                                        </span>
                                                        {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                      </div>
                                                      {field?.fieldHelp &&
                                                        <span>
                                                          <BsFillQuestionCircleFill
                                                            title={field?.fieldHelp}
                                                            style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                          />
                                                        </span>
                                                      }
                                                    </h5>
                                                  </div>
                                                  <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }} className="hstack gap-2">
                                                    <div className="w-100">
                                                      <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                        {field?.hourLabel}
                                                      </h5>
                                                      <Form.Select
                                                        className="br3"
                                                        required
                                                        style={{ fontSize: 12 }}
                                                      >
                                                        <option>Select Hour</option>
                                                        <option>UNK</option>
                                                        {(field?.clockTimeFormat === "24" ? hours24 : hours12)?.map((hour, i) => (
                                                          <option key={i} value={hour}>
                                                            {hour}
                                                          </option>
                                                        ))}
                                                      </Form.Select>
                                                    </div>
                                                    <div className="w-100">
                                                      <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                        {field?.minuteLabel}
                                                      </h5>
                                                      <Form.Select
                                                        className="br3"
                                                        required
                                                        style={{ fontSize: 12 }}
                                                      >
                                                        <option>Select Minute</option>
                                                        <option>UNK</option>
                                                        {minuteSecond?.map((minute, i) => (
                                                          <option key={i} value={minute}>
                                                            {minute}
                                                          </option>
                                                        ))}
                                                      </Form.Select>
                                                    </div>
                                                    {field?.timeFormat === "hhmmss" &&
                                                      <div className="w-100">
                                                        <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                          {field?.secondLabel}
                                                        </h5>
                                                        <Form.Select
                                                          className="br3"
                                                          required
                                                          style={{ fontSize: 12 }}
                                                        >
                                                          <option>Select Second</option>
                                                          <option>UNK</option>
                                                          {minuteSecond?.map((second, i) => (
                                                            <option key={i} value={second}>
                                                              {second}
                                                            </option>
                                                          ))}
                                                        </Form.Select>
                                                      </div>
                                                    }
                                                  </div>
                                                </>
                                              ) : field?.type === "score" && (
                                                <>
                                                  <div className="d-flex justify-content-between align-items-center my-2">
                                                    <h5 className={`d-flex gap-2 mb-0`}>
                                                      <div className="d-flex gap-2">
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                          {field?.fieldLabelType ?
                                                            <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                            :
                                                            <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                          }
                                                        </span>
                                                        {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                      </div>
                                                      {field?.fieldHelp &&
                                                        <span>
                                                          <BsFillQuestionCircleFill
                                                            title={field?.fieldHelp}
                                                            style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                          />
                                                        </span>
                                                      }
                                                    </h5>
                                                  </div>
                                                  <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                    <ScorePercentageGraph
                                                      scoreType={field?.scoreType}
                                                      startScore={field?.startScore}
                                                      endScore={field?.endScore}
                                                      boxColumn={field?.boxColumn}
                                                      dataEntryType
                                                    />
                                                    {field?.customFieldRemark === "yes" &&
                                                      <>
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-0`}>
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >
                                                              {field?.customFieldRemarkLabel}
                                                            </span>
                                                          </h5>
                                                        </div>
                                                        <Form.Control
                                                          style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                          as="textarea"
                                                          placeholder={"Enter Remark"}
                                                        />
                                                      </>
                                                    }
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          </Form.Group>
                                        )}
                                      </Draggable>
                                    ))}
                                    {provided.placeholder}
                                  </Row>
                                </Container>
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </>
                }
                {formId &&
                  <div className="w-100 p-2 pe-3 border-top bg-light text-end">
                    <button
                      disabled={duplicatesFieldName?.length > 0 || buttonLoader}
                      onClick={addUpdateGlobalFormFields}
                      className="updateProfile"
                    >
                     {buttonLoader ? (
                        <div className="hstack gap-2">
                          <Spinner size="sm"/> Saving...
                        </div>
                      ) : (
                        "Save Form"
                      )}
                      
                    </button>
                  </div>
                }
              </div>
            </Form.Group>
            {formId &&
              <Form.Group as={Col} md={1} className="border-start p-0 overflow-auto" style={{ height: "calc(100vh - 145px)" }}>
                <div className="hstack gap-2 flex-wrap p-2">
                  {[
                    "heading",
                    "text",
                    "number",
                    "textarea",
                    "date",
                    "time",
                    "dropdown",
                    "radio",
                    "checkbox",
                    "scale",
                    "range",
                    "score",
                    "file",
                  ].map((field) => (
                    <button
                      key={field}
                      style={{ fontSize: 10 }}
                      title={`Add ${field}`}
                      className="py-1 px-2 CP border btn-outline-secondary btn w-100"
                      onClick={() => handleAddFormField(field)}
                    >
                      {field.charAt(0).toUpperCase() + field.slice(1)}
                    </button>
                  ))}
                  <button
                    style={{ fontSize: 10 }}
                    title={`View Fiels Library`}
                    onClick={setToggleLibrary}
                    className="py-1 px-2 CP border btn-outline-secondary btn w-100"
                  >
                    Library
                  </button>
                </div>
              </Form.Group>
            }
          </Row>
        </Container>
      </SplitPane>
      <FormCustomization
        studyId={studyId}
        Show={!toggle}
        setActiveTab={setActiveTab}
        activeTab={activeTab}
        Hide={setToggle}
        handleUpdateFormField={handleUpdateFormField}
        fieldId={fieldId}
        formId={formId}
        formFields={formFields?.filter(item => item.id !== fieldId)}
        setFormFields={setFormFields}
        conditionaLogicTab={conditionaLogicTab}
        setConditionaLogicTab={setConditionaLogicTab}
        formCategory={formCategory}
        formType={formType}
        conditional
        customForm={customForm}
        domainCode={domainCode}
        domainLabel={domainLabel}
        formMetadataList={formMetadataList?.filter(item => (item.category === formCategory || item.category === "all"))}
        fieldData={formFields?.find(item => item.id === fieldId)}
      />
      <FormFieldLibrary
        Show={!toggleLibrary}
        Hide={setToggleLibrary}
        setCategoryId={setCategoryId}
        categoryId={categoryId}
        formFieldLibraryList={formFieldLibraryList}
        setFormFields={setFormFields}
        formFields={formFields}
      />
    </>
  );
};

export default FormEditor;
